export default __webpack_public_path__ + "static/pineapple_adventure_3-abc722a7bf235472d3cb0e7abcfe08ed.png";